// Maltese translations
export const mt: Record<string, string> = {
  'menu.dashboard': 'Dashboard',
  'menu.customers': 'Klijenti',
  'menu.products': 'Prodotti',
  'menu.users': 'Utenti',
  'menu.settings': 'Settings',
  'menu.logout': "Oħroġ",
  'dashboard.title': 'Dashboard',
  'dashboard.newOrder': 'Ordni ġdida',
  'order.title': 'Ordni ġdida',
  'order.customer': 'Klijent',
  'order.products': 'Prodotti',
  'order.total': 'Total',
  'users.title': 'Utenti',
  'users.name': 'Isem',
  'users.email': 'Email',
  'common.yes': 'Iva',
  'common.no': 'Le',
  'common.cancel': 'Ikkanċella',
  'common.save': 'Issejvja',
  'common.search': 'Fittex',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': "Idħol",
  'login.welcome': 'Merħba, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'Email',
  'signup.phone': 'Telefon',
  'menu.reportsAndAccounting': 'Rapporti u Kontabilità',
  'menu.systemAndCommunication': 'Sistema u Komunikazzjoni',
};